<template>
  <div style="padding: 0" id="login">
    <img src="../../assets/pagebottomPng.png" class="p_a" style="right: 0;bottom: 0" width="50%"/>
    <div class="p_r">
      <img src="../../assets/surveryBack.png" width="100%"/>
      <div style="top: 25%;left: 10%;width: 50%" class="f_w colorWhite p_a font16">{{surModel.researchName}}</div>
      <img style="left: 0;bottom: 0%" src="../../assets/topGen.png" class="p_a" width="25%"/>
    </div>
    <div style="margin-bottom: 40px;margin-top: -15%;position: relative;z-index: 1">
      <div :key="index" class="surAnswer" v-for="(item, index) in surModel.subjects">
        <div class="sanjiaoarr top">
          <img src="../../assets/sanjiaoarr.png" width="50px"/>
          <span style="position: absolute;top: 0;left: 0;width: 25px;height: 25px;text-align: center;line-height: 25px;color: #fff;font-size: 16px;">{{index + 1}}</span>
        </div>
        <div class="sanjiaoarr bottom">
          <img src="../../assets/sanjiaoarr.png" width="50px"/>
        </div>
        <div :style="{'display': item.subjectType === '填空' ? 'inline-block' : ''}">
<!--          <span class="tips">{{item.subjectType}}</span> -->
          <span :class="item.subjectType === '问答' && item.isRequired ? 'required' : ''" class="fontClass" v-if="item.subjectType !== '填空'">{{item.desc}}</span>
        </div>
        <div v-if="item.subjectType !== '问答' && item.subjectType !== '评分' && item.subjectType !== '填空'">
          <div @click="seletAnswer(item, childrenItem,index)" class="answers" :key="childrenIndex" :class="childrenItem.selected ? 'select' : ''" v-for="(childrenItem, childrenIndex) in item.items">
            <div class="fontClass keyClass" style="display: inline-block;width: 20px;vertical-align: middle;">{{ childrenItem.itemKey }}</div>
            <div class="fontClass" :style="{'width': (childrenItem.correctItem && childrenItem.selected && item.isAnswered) || (((!childrenItem.correctItem && childrenItem.selected) ) && item.isAnswered) ? 'calc(100% - 63px)' : 'calc(100% - 27px)'}" style="display: inline-block;vertical-align: middle;">{{ childrenItem.itemValue }}</div>
<!--            || (childrenItem.correctItem && !childrenItem.selected)-->
            <div v-if="((!childrenItem.correctItem && childrenItem.selected) ) && item.isAnswered" style="display: inline-block;width: 32px;vertical-align: middle">
              <span style="float: right;display: inline-block;color: #ff0000;font-size: 12px">
                <img src="../../assets/errorAnswerPic.png" width="100%"/>
              </span>
            </div>
            <div v-if="childrenItem.correctItem && childrenItem.selected && item.isAnswered" style="display: inline-block;width: 32px;vertical-align: middle">
              <span style="float: right;display: inline-block;color: #0bc98b;font-size: 14px">
                <img src="../../assets/rightAnswerPic.png" width="100%"/>
              </span>
            </div>
          </div>
          <div v-if="item.subjectType === '多选' && item.setCorrectAnswer && !item.isAnswered" class="t_c m_t_20">
            <button @click="showCorrectAnswer(item)" style="width: 40%;padding: 2% 0" class="redButton">查看正确答案</button>
          </div>
          <div v-if="item.setCorrectAnswer && item.isAnswered" class="m_t_10 m_l_10">
            <div><span class="fontClass">正确答案:</span> <span class="fontClass">{{returnCorrectAnswer(item)}}</span></div>
            <div>
<!--              <span class="fontClass">解析：</span>-->
              <span class="fontClass" v-html="item.answerAnalysis"></span></div>
          </div>
        </div>
        <div class="p_r" style="z-index: 1;" v-if="item.subjectType === '问答'">
          <textarea :disabled="isSubMit" style="width: calc(100% - 20px);font-size: 14px;border-radius: 15px;border: 1px solid rgba(247, 203, 203, 100);" rows="5" v-model="item.answerValue" class="allTextarea m_t_20"></textarea>
        </div>
        <div class="p_r" style="margin-top: 10px;z-index: 1" v-if="item.subjectType === '评分'">
          <div style="word-break: break-all" class="d_i w20 fontClass t_c v_m">{{ item.items[0].itemValue }}</div><div style="margin: 0 2.5%;width: 55%" class="answerPingfen v_m d_i">
            <input :id="index + 'answerName1'" checked="checked" :name="'answer' + index" value="1" v-model="item.answerValue" type="radio"><label :style="{'background-color': parseInt(item.answerValue) >= 1 ? '#FADCDD' : '', 'color': parseInt(item.answerValue) >= 1 ? '#fff' : '', 'border': parseInt(item.answerValue) >= 1 ? '1px solid transparent' : ''}" :for="index + 'answerName1'">1</label><input :id="index + 'answerName2'" :name="'answer' + index" value="2" v-model="item.answerValue" type="radio"><label :style="{'background-color': parseInt(item.answerValue) >= 2 ? '#eebec0' : '', 'color': parseInt(item.answerValue) >= 2 ? '#fff' : '', 'border': parseInt(item.answerValue) >= 2 ? '1px solid transparent' : ''}" :for="index + 'answerName2'">2</label><input :id="index + 'answerName3'" :name="'answer' + index" value="3" v-model="item.answerValue" type="radio"><label :style="{'background-color': parseInt(item.answerValue) >= 3 ? '#eb8086' : '', 'color': parseInt(item.answerValue) >= 3 ? '#fff' : '', 'border': parseInt(item.answerValue) >= 3 ? '1px solid transparent' : ''}" :for="index + 'answerName3'">3</label><input :id="index + 'answerName4'" :name="'answer' + index" value="4" v-model="item.answerValue" type="radio"><label :style="{'background-color': parseInt(item.answerValue) >= 4 ? '#e14d55' : '', 'color': parseInt(item.answerValue) >= 4 ? '#fff' : '', 'border': parseInt(item.answerValue) >= 4 ? '1px solid transparent' : ''}" :for="index + 'answerName4'">4</label><input :id="index + 'answerName5'" :name="'answer' + index" value="5" v-model="item.answerValue" type="radio"><label :style="{'background-color': parseInt(item.answerValue) >= 5 ? '#f52934' : '', 'color': parseInt(item.answerValue) >= 5 ? '#fff' : '', 'border': parseInt(item.answerValue) >= 5 ? '1px solid transparent' : ''}" :for="index + 'answerName5'">5</label>
          </div><div style="word-break: break-all" class="d_i v_m fontClass t_c w20">{{ item.items[4].itemValue }}</div>
        </div>
        <span v-if="item.subjectType === '填空'">
          <span class="fontClass">{{item.beforeDesc}}</span>
          <div class="p_r m_t_10" style="z-index: 1;">
            <input :disabled="isSubMit" style="width: calc(50% - 20px);border: 1px solid rgba(247, 203, 203, 100);border-radius: 100px" rows="1" v-model="item.answerValue" class="allInput">
            <span class="fontClass" style="margin-left: 10px;">{{item.afterDesc}}</span>
          </div>
<!--          <div class="m_t_10">-->
<!--            <span>{{item.afterDesc}}</span>-->
<!--          </div>-->
        </span>
        <img src="../../assets/answerGen.png" class="p_a" style="right: 0%;bottom: 0%;opacity: 0.7;" width="30%"/>
      </div>
      <div style="margin-bottom: 80px">
        <div v-if="!isSubMit" class="t_c" style="margin-top: 50px">
          <button :disabled="canSave" @click="save" style="width: 90%;padding: 3% 0;font-size: 18px;border-radius:10px;box-shadow: 0px 10px 16px 0px rgba(0, 0, 0, 0.12);" class="redButton">提 交</button>
          <button v-if="type === 1 || type === '1'" @click="goback" style="width: 90%;margin-left:5%;padding: 3% 0;border-radius:10px;margin-right: 20px;font-size: 18px;margin-top: 10px;box-shadow: 0px 10px 16px 0px rgba(0, 0, 0, 0.12);" class="cancelButtonTwo">返回</button>
        </div>
        <div class="t_c" v-if="allowSkip === 'True' || allowSkip === 'true'">
          <span @click="skip" style="text-decoration: underline;margin-top: 20px;display: inline-block">跳过</span>
        </div>
      </div>
    </div>
    <div v-if="showConfirm">
      <div class="alertcover"></div>
      <div style="border-radius: 20px;" class="allalertModel">
        <div style="padding: 10px;background-color: #E7625B;border-radius: 20px;">
          <div style="margin-top: 20px">
            <img width="100%" src="../../assets/surverySurn.png" alt="">
          </div>
          <div style="letter-spacing: 3px;color: #fff;margin-top: 20px;margin-bottom: 20px;font-size: 20px">感谢您的参与！</div>
        </div>
      </div>
    </div>
    <div v-if="showAlready">
      <div class="alertcover"></div>
      <div style="background-color: transparent" class="allalertModel">
        <div style="">
          <div>
            <img width="100%" src="../../assets/surAlready.png" alt="">
          </div>
<!--          <div style="letter-spacing: 3px;color: #fff;margin-top: 20px;margin-bottom: 20px;font-size: 20px">感谢您的参与！</div>-->
        </div>
      </div>
    </div>
    <div v-if="showHCP">
      <div class="alertcover"></div>
      <div style="background-color: transparent" class="allalertModel">
        <div style="">
          <div>
            <img width="100%" src="../../assets/suralertImg.png" alt="">
          </div>
          <!--          <div style="letter-spacing: 3px;color: #fff;margin-top: 20px;margin-bottom: 20px;font-size: 20px">感谢您的参与！</div>-->
        </div>
      </div>
    </div>
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>
</template>

<script>
import { Dialog} from "vant";
import "vant/lib/dialog/style";
import merge from 'webpack-merge';
let timeout
import agreeBookDialog from "./agreeBookDialog";
export default {
  name: 'login',
  data () {
    return {
      isSubMit: false,
      ABDialogShow:false,
      showConfirm: false,
      showAlready: false,
      showHCP: false,
      id: parseInt(this.$route.query.id),
      redirectUrl: this.$route.query.redirectUrl,
      returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
      meetingreturnurl: decodeURIComponent(this.$route.query.meetingreturnurl || this.$route.query.meetingReturnUrl || ''),
      takedacode: this.$route.query.takedacode || '',
      allowSkip: this.$route.query.allowSkip || '',
      meetingSurveyId: this.$route.query.meetingSurveyId || '',
      jumptovctag: this.$route.query.jumptovctag || '',
      NewerTag: this.$route.query.NewerTag || '',
      meetingEmscode: this.$route.query.meetingEmscode || '',
      meetingSurveryBack: this.$route.query.meetingSurveryBack || '',
      articleId: parseInt(this.$route.query.articleId || 0),
      type: this.$route.query.type || '',
      openId: '',
      appid: '',
      surModel: {
        id: 0,
        researchNo: '',
        researchName: '',
        bu: '',
        product: '',
        customTag: '',
        subjects: [
        ],
        isShowWujiahuiMeeting: true
      },
      startId: '',
      selectNum:[]
    }
  },
    components: { agreeBookDialog },
  created () {
    if (timeout) {
      clearTimeout(timeout)
    }
    if (this.meetingreturnurl || this.meetingSurveyId || this.meetingEmscode) {
      this.type = 2
    }

//判断会传参数中是否有 jumptovctag ，如有则证明已经跳过了，如无，则无论如何都跳转
if(!this.jumptovctag){
  let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent(window.location.href + '&noQRcode=true&needReturn=true')
      window.location.href = url
 }

     //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
     if(this.NewerTag=='Hcp'){
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag=='Emp')
    {
      window.localStorage.setItem('isEmployee', true);

    }
    else if(this.NewerTag=='NoHcp')
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
    }

    if (!localStorage.TaToken && !this.takedacode) {
      // process.env.config.baseUrl
      // window.location.host
      let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent(window.location.href + '&noQRcode=true&needReturn=true')
      window.location.href = url
    } else {
      if (this.takedacode && !localStorage.TaToken) {
        this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
          localStorage.TaToken = msg.token
          localStorage.appId = msg.appId
          localStorage.openId = msg.openId
          this.openId = msg.openId
          this.appid = msg.appId
          this.checkSur()
          if (this.id) {
            this.getDetail()
          }
        })

      setTimeout(() => {
        this.getSignDetail();
        this.$router.push({
query:merge(this.$route.query,{'jumptovctag':''})
})
      }, 1000);

      } else {
        this.openId = localStorage.openId

      setTimeout(() => {
        this.getSignDetail();
        this.$router.push({
query:merge(this.$route.query,{'jumptovctag':''})
})
      }, 1000);


        this.checkSur()
        this.appid = localStorage.appId
        let data = {
          openId: this.openId,
          returnurl: encodeURIComponent(window.location.href),
          docCode: ''
        }
        let data2 = {
          openId: this.openId,
          returnurl: encodeURIComponent(window.location.href)
        }
        this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data2).then(p2 => {
          if (p2.data.status === 1) {
            this.showHCP = true
            // this.$commonJs.mobileDoubleComfirm({
            //   buttonType: '0',
            //   type: 'warning',
            //   title: '提示',
            //   content: '该调研仅开放给已注册的医疗卫生专业人士（HCP）！',
            //   successFun: () => {
            //   },
            //   errorFun: () => {
            //   }
            // })
            return
          }
          this.$axiox.postNoRes('/api/wechat/getNonHcpstatus', data).then(p3 => {
            if (p3.data.status === 1) {
              this.showHCP = true
              // this.$commonJs.mobileDoubleComfirm({
              //   buttonType: '0',
              //   type: 'warning',
              //   title: '提示',
              //   content: '该调研仅开放给已注册的医疗卫生专业人士（HCP）！',
              //   successFun: () => {
              //   },
              //   errorFun: () => {
              //   }
              // })
              return
            }
            this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getdoctorstatus', data).then(p => {
              if (p.data.status === 2) {
                // encodeURIComponent(window.location.href)
                //window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href) + '&noQRcode=true&needReturn=true')
              }
            })
          })
          if (this.id) {
            this.getDetail()
          }
        })
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    clearTimeout(timeout)
    next();
  },
  mounted () {
    // this.sendResource()
    if (process.env.config.seviceUrl.indexOf('wechatweb.takeda.com.cn') > -1) {
      document.title = '吾医空间'
    } else {
      document.title = '吾医空间测试号'
    }
  },
  computed: {
    canSave () {
      let flag = false
      for (let i = 0; i < this.surModel.subjects.length; i++) {
        if (this.surModel.subjects[i].subjectType !== '问答' && this.surModel.subjects[i].subjectType !== '评分' && this.surModel.subjects[i].subjectType !== '填空') {
          let num = 0
          if (this.surModel.subjects[i].items) {
            for (let j = 0; j < this.surModel.subjects[i].items.length; j++) {
              if (this.surModel.subjects[i].items[j].selected) {
                num++
              }
            }
          }
          if (num === 0) {
            flag = true
          }
        }
        if ((this.surModel.subjects[i].subjectType === '问答' && this.surModel.subjects[i].isRequired) || this.surModel.subjects[i].subjectType === '评分' || this.surModel.subjects[i].subjectType === '填空') {
          if (!this.surModel.subjects[i].answerValue) {
            console.log(this.surModel.subjects[i].answerValue)
            flag = true
          }
        }
      }
      return flag
    }
  },
  methods: {
    getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {
          //name: "agreeBook",
            this.ABDialogShow = true;
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    },
    startRead () {
      let data = {
        researchId: this.id,
        openid: this.openId,
        researchType: this.type || 0,
        meetingEmscode: this.$route.query.meetingEmscode,
        articleId: parseInt(this.$route.query.articleId || 0),
        researchNo: this.surModel.researchNo,
        researchName: this.surModel.researchName
      }
      console.log(data)
      let url = this.$commonJs.returnQuery('/api/ArticlDoctor/readstart', data)
      this.$axiox.post('/api/ResearchDoctorRead/readstart', data).then(p => {
        console.log(p, 'startReadNew')
        this.startId = p
        this.endRead()
      })
    },
    endRead () {
      clearTimeout(timeout)
      timeout = setTimeout(p => {
        let randomTime = (Math.floor(Math.random() * 15) + 15) * 1000
        console.log(randomTime)
        this.$axiox.get('/api/ResearchDoctorRead/readend/' + this.startId, true).then(p => {
          setTimeout(_ => {
            this.endRead()
          }, randomTime)
        })
      }, 1000)
    },
    sendResource () {
      let data = {
        surveyId: this.meetingSurveyId,
        customerId: this.openId,
        content: '成功'
      }
      this.$axiox.postNoRes('/api/Research/wujiahui/records', data).then(p => {

        if (this.meetingSurveryBack === 'true' || this.meetingSurveryBack === 'True') {
          console.log(this.meetingSurveryBack)
          this.goback()
        } else {
          window.location.href = this.meetingreturnurl
        }
      })
    },
    showCorrectAnswer (item) {
      let num = 0
      for (let i = 0; i < item.items.length; i++) {
        if (item.items[i].selected) {
          num++
        }
      }
      if (num === 0) {
        this.$commonJs.showTips('请先选择答案')
      } else {
        item.isAnswered = true
      }
    },
    returnCorrectAnswer (item) {
      let html = ''
      for (let i = 0; i < item.items.length; i++) {
        if (item.items[i].correctItem) {
          html += item.items[i].itemKey
        }
      }
      return html
    },
    checkSur () {
      this.$axiox.get('/api/Research/records/isSubmited?openid=' + this.openId + '&researchId=' + this.id + '&type=' + (this.type || 0) + '&articleId=' + (this.articleId || 0) + '&meetingemscode=' + (this.meetingEmscode || '')).then(p => {
        if (p === 'True') {
          this.isSubMit = true
          this.showAlready = true
          // this.$commonJs.mobileDoubleComfirm({
          //   buttonType: '0',
          //   type: 'warning',
          //   title: '提示',
          //   content: '您已参与过此调研',
          //   successFun: () => {
          //   },
          //   errorFun: () => {
          //   }
          // })
        } else {
        }
      })
    },
    skip () {
      if (this.meetingSurveryBack === 'true' || this.meetingSurveryBack === 'True') {
        this.goback()
      } else {
        window.location.href = this.meetingreturnurl
      }
    },
    goback () {
      window.history.back()
    },
    save () {
      let postData = []
      for (let i = 0; i < this.surModel.subjects.length; i++) {
        if (this.surModel.subjects[i].subjectType !== '问答' && this.surModel.subjects[i].subjectType !== '评分' && this.surModel.subjects[i].subjectType !== '填空') {
          for (let j = 0; j < this.surModel.subjects[i].items.length; j++) {
            if (this.surModel.subjects[i].items[j].selected) {
              let data = {
                openId: this.openId,
                meetingEmscode: this.meetingEmscode,
                articleId: this.articleId || 0,
                researchId: this.surModel.id,
                researchNo: this.surModel.researchNo,
                researchName: this.surModel.researchName,
                researchType: this.type || 0,
                subjectId: this.surModel.subjects[i].subjectId,
                subjectType: this.surModel.subjects[i].subjectType,
                subjectSort: this.surModel.subjects[i].sort,
                subjectDesc: this.surModel.subjects[i].desc,
                subjectItemKey: this.surModel.subjects[i].items[j].itemKey,
                subjectItemValue: this.surModel.subjects[i].items[j].itemValue,
                answer: ''
              }
              postData.push(data)
            }
          }
        } else {
          if (this.surModel.subjects[i].subjectType === '评分') {
            let data = {
              openId: this.openId,
              meetingEmscode: this.meetingEmscode,
              articleId: this.articleId || 0,
              researchId: this.surModel.id,
              researchNo: this.surModel.researchNo,
              researchName: this.surModel.researchName,
              researchType: this.type || 0,
              subjectId: this.surModel.subjects[i].subjectId,
              subjectType: this.surModel.subjects[i].subjectType,
              subjectSort: this.surModel.subjects[i].sort,
              subjectDesc: this.surModel.subjects[i].desc,
              subjectItemKey: this.surModel.subjects[i].items[parseInt(this.surModel.subjects[i].answerValue) - 1].itemKey,
              subjectItemValue: this.surModel.subjects[i].items[parseInt(this.surModel.subjects[i].answerValue) - 1].itemValue,
              answer: ''
            }
            postData.push(data)
          } else {
            let data = {
              openId: this.openId,
              meetingEmscode: this.meetingEmscode,
              articleId: this.articleId || 0,
              researchId: this.surModel.id,
              researchNo: this.surModel.researchNo,
              researchName: this.surModel.researchName,
              researchType: this.type || 0,
              subjectId: this.surModel.subjects[i].subjectId,
              subjectType: this.surModel.subjects[i].subjectType,
              subjectSort: this.surModel.subjects[i].sort,
              subjectDesc: this.surModel.subjects[i].desc,
              subjectItemKey: '',
              subjectItemValue: '',
              answer: this.surModel.subjects[i].answerValue || ''
            }
            postData.push(data)
          }
        }
      }
      console.log(postData)
      this.$axiox.post('/api/Research/records', postData).then(p => {
        if (this.type !== 0 && this.type !== '0') {
          this.$commonJs.showTips('提交成功')
        } else {
          this.showConfirm = true
        }
        this.isSubMit = true
        setTimeout(p => {
          if (this.meetingEmscode || this.meetingSurveyId) {
            this.sendResource()
          } else {
            if (this.type === 1 || this.type === '1') {
              this.goback()
            }
          }
        }, 2000)
      })
    },
    seletAnswer (item, childrenItem,index) {
      if (this.isSubMit) {
        return
      }
      if (item.setCorrectAnswer && item.isAnswered) {
        return
      }
      if (item.subjectType === '多选') {
        if(item.maxNum==null || item.maxNum==0  || (item.maxNumSwitch!=true)){
          childrenItem.selected = !childrenItem.selected
        }else{
          if(this.selectNum[index]>=item.maxNum && childrenItem.selected==false){
          Dialog.alert({
            message:'最多选择'+item.maxNum+'项',
            theme:'round-button'
          })
          return
          }
          childrenItem.selected = !childrenItem.selected
          if(childrenItem.selected==true){
            this.selectNum[index]++
          }else{
            this.selectNum[index]--
          }
        }
        
      }
      if (item.subjectType === '单选') {
        if (childrenItem.selected) {
          childrenItem.selected = false
        } else {
          for (let i = 0; i < item.items.length; i++) {
            item.items[i].selected = false
          }
          childrenItem.selected = true
        }
        if (item.setCorrectAnswer) {
          item.isAnswered = true
        }
      }
    },
    getDetail () {
      this.$axiox.get('/api/Research/detail/' + this.id).then(p => {
        for (let i = 0; i < p.subjects.length; i++) {
          p.subjects[i].answerValue = ''
          this.$set(p.subjects[i], 'isAnswered', false)
          if (p.subjects[i].items) {
            for (let j = 0; j < p.subjects[i].items.length; j++) {
              p.subjects[i].items[j].selected = false
            }
          }
        }
        this.surModel = p
        for(let j=0;j<this.surModel.subjects.length;j++){
          this.selectNum[j]=0
        }
        this.startRead()
      })
    }
  }
}
</script>

<style scoped>
.sl_color {
  color: #408deb;
}
#login {
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: auto;
  padding: 0 5%;
  background-color: #fff;
}
.title {
  margin-top: 5px;
  font-size: 14px;
}

.audioPlay {
  width: 100%;
  margin: 10px 0;
}
.read-icon {
  display: inline-block;
  width: 16px;
  height: 11px;
}
.read-txt {
  margin-left: 5px;
  color: rgba(16, 16, 16, 100);
  font-size: 12px;
  text-align: left;
  font-family: PingFangSC-regular;
}
.bottom-icon-box {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  text-align: center;
  padding-bottom: 15px;
}
.bottom-icons {
  display: inline-block;
  width: 61px;
  height: 61px;
  margin: 0 20px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 100);
  box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.19);
  position: relative;
}
.icons-img {
  width: 30px;
  height: 30px;
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%)
}
.icons-checked {
  background-color: #F00E00;
}
.fontClass {
  font-size: 14px;
  line-height: 25px;
  letter-spacing: 1px;
  color: #5a5a5a;
}
</style>



// WEBPACK FOOTER //
// src/components/login/mobileSurvey.vue